import React, { useEffect, useState } from "react";
import axios from "axios";
import { config } from "../../../config";

const apiUrl = config.apiUrl;

const CreateContactPage = ({ onContactPageCreated }) => {
  const [formData, setFormData] = useState({
    phone: "",
    email: "",
    address: "",
    headline: "",
    paragraph: "",
  });

  const [error, setError] = useState(null);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  useEffect(() => {
    // Check if contact page already exists
    const checkContactPage = async () => {
      try {
        const response = await axios.get(`${apiUrl}/contactpages`);
        console.log(response);
        if (response.data.contactPages && response.data.contactPages.length > 0) {
          // If contact page already exists, redirect or call onContactCreated
          onContactPageCreated(); // Redirect or do whatever is needed
        }
      } catch (err) {
        console.error("Error checking contact page existence", err);
      }
    };

    checkContactPage();
  }, [onContactPageCreated]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      await axios.post(`${apiUrl}/contactpages`, formData, {
        headers: {
          "Content-Type": "application/json",
        },
      });
      alert("Contact Page Created Successfully!");
      onContactPageCreated(); // Redirect after successful creation
    } catch (err) {
      setError("An error occurred while creating the contact page.");
    }
  };

  return (
    <div className="p-6 max-w-lg mx-auto bg-white shadow rounded">
      <h2 className="text-2xl font-bold mb-4">Create Contact Page</h2>
      {error && <p className="text-red-500">{error}</p>}
      <form onSubmit={handleSubmit}>
        {/* Phone */}
        <div className="mb-4">
          <label className="block text-gray-700">Phone</label>
          <input
            type="text"
            name="phone"
            value={formData.phone}
            onChange={handleChange}
            className="border w-full p-2"
            required
          />
        </div>

        {/* Email */}
        <div className="mb-4">
          <label className="block text-gray-700">Email</label>
          <input
            type="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            className="border w-full p-2"
            required
          />
        </div>

        {/* Address */}
        <div className="mb-4">
          <label className="block text-gray-700">Address</label>
          <textarea
            name="address"
            value={formData.address}
            onChange={handleChange}
            className="border w-full p-2"
            required
          ></textarea>
        </div>

        {/* Headline */}
        <div className="mb-4">
          <label className="block text-gray-700">Headline</label>
          <input
            type="text"
            name="headline"
            value={formData.headline}
            onChange={handleChange}
            className="border w-full p-2"
            required
          />
        </div>

        {/* Paragraph */}
        <div className="mb-4">
          <label className="block text-gray-700">Paragraph</label>
          <textarea
            name="paragraph"
            value={formData.paragraph}
            onChange={handleChange}
            className="border w-full p-2"
            required
          ></textarea>
        </div>

        {/* Submit Button */}
        <button
          type="submit"
          className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700"
        >
          Create Contact Page
        </button>
      </form>
    </div>
  );
};

export default CreateContactPage;
